export default __webpack_public_path__ + "static/media/emoji-smile.f3da2b85.svg";